<script>
import DataLayer from '@services/data-layer/index'
import MixGridBlock from '@components/mix-grid-block'

export default {
    components: { MixGridBlock },
    data() {
        return {
            mixes: [],
        }
    },
    mounted() {
        DataLayer.mixes.getLatest(6).then(mixes => {
            this.mixes = mixes.body
        })
    },
}
</script>

<template>
    <div
        v-if="mixes && mixes.length"
        :class="$style.section"
    >
        <BaseSection
            :show-all-link="{ name: 'browse/mixes/latest' }"
            title="New Releases"
            show-all-title="Browse More"
            padded
        >
            <MixGridBlock :mixes="mixes" />
        </BaseSection>
    </div>
</template>

<style lang="scss" module>
@import '@design';

.section {
    margin-top: $s-xxl;
}
</style>
